/* leverege-molten no-export */
import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
import Util from "./Util.js";
const {
  t,
  tf,
  tIcon
} = I18N.ns('molten.screens.account.BetaSwitch');
export default {
  id: 'molten.BetaSwitch',
  matches: {
    use: 'userBar',
    client: 'Main'
  },
  name: tf('name', {
    state: tf('on')
  }),
  layout: Config.get('BetaSwitch', 'switchLayout', {
    group: ['beta'],
    groupIcons: [() => {
      return Util.isBetaOn() ? tIcon('betaIconOn', 'https://molten-ui-assets.storage.googleapis.com/icon-beta-on.png') : tIcon('betaIconOff', 'https://molten-ui-assets.storage.googleapis.com/icon-beta-off.png');
    }],
    groupNames: ['Beta Mode'],
    sort: '__a.a',
    sectionName: 'UI Version'
  }),
  sort: '__a',
  handles: () => {
    return Config.get('BetaSwitch', 'enabled', false);
  },
  appearance: () => {
    return Util.isBetaOn() ? {
      name: t('name', {
        state: t('off')
      }),
      icon: tIcon('betaIconOn', 'https://molten-ui-assets.storage.googleapis.com/icon-beta-on.png')
    } : {
      name: t('name', {
        state: t('on')
      }),
      icon: tIcon('betaIconOff', 'https://molten-ui-assets.storage.googleapis.com/icon-beta-off.png')
    };
  },
  perform: () => {
    const redirect = Util.isBetaOn() ? `https://${Config.get('BetaSwitch', 'normalHost')}${window.location.pathname}` : `https://${Config.get('BetaSwitch', 'betaHost')}${window.location.pathname}`;
    window.location.href = redirect;
  }
};